import React from "react";
import { Routes, Route } from "react-router-dom";
import ReportSubscriptions from "./reportSubscriptions";

const RptSubRouter = () => {
  return (
    <div
      className="rpt-sub-router-div"
      style={{
        width: "100%",
        height: "100%",
        paddingBottom: "10px",
        minHeight: "0px",
      }}
    >
      <Routes>
        <Route path="/*" element={<ReportSubscriptions />} />
      </Routes>
    </div>
  );
};

export default RptSubRouter;